import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=228fd0da&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"
import style0 from "./Error404.vue?vue&type=style&index=0&id=228fd0da&prod&lang=scss"
import style1 from "./Error404.vue?vue&type=style&index=1&id=228fd0da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fd0da",
  null
  
)

export default component.exports